// src/oura/delivery/startPlanHint.ts
//
// The one sentence every "nothing sold yet" screen ends with, so Delivery,
// Contract and Timeline cannot send staff to different controls. Which control
// exists depends on `showOnboarding`: the banner when it is on, More when not
// (the same switch ClientReviews.tsx reads).

import { showOnboarding } from "../nav";

export const START_PLAN_HINT = showOnboarding
    ? "Start it from the banner at the top of the Client tab."
    : "Open More on the Client tab, then choose Start a plan.";
